var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[_vm.styling, { active: _vm.active, dark: _vm.dark }],style:(`background-color: #${_vm.color}`),attrs:{"title":_vm.title,"disabled":_vm.disabled ? 'disabled' : false},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }